import React, { PureComponent } from 'react';
import { ShowModifier } from './Accordion';
import { calculatePizzaModifierBuilderCost } from '../../dashboard/components/items/components/PizzaCreatorModifiers/utils';

class ModifiersByServing extends PureComponent {
  render() {
    const { servingTitle, servingModifiers } = this.props;
    return (
      <div>
          <div className="order-panel-item-modifier-group-title">
          {servingTitle}
          </div>
          <div>
            {servingModifiers.map( (servingModifier, key) => (
                <ShowModifier
                      key={key}
                      strike={false}
                      ingredient={
                        {
                          title: servingModifier.title+', '+servingModifier.selected_amount.label,
                          cost: calculatePizzaModifierBuilderCost(servingModifier.cost, servingModifier.selected_amount, servingModifier.selected_serving),
                          availability: servingModifier.availability,
                        }
                      }
                />
              ))}
          </div>
      </div>
    );
  }
}

export default ModifiersByServing;



// WEBPACK FOOTER //
// ./src/views/common/OrderPanel/ModifiersByServing.jsx